import { Action } from '@ngrx/store';
import { Lease } from '../../model';
import { type } from "../types";
import { GenericIdTitle } from "../../model/BaseModel";

export const LeasesActionTypes = {
  LOAD_ALL_LEASES: type('[app] [LEASE] Load all lease'),
  LOAD_ALL_LEASES_FAILED: type('[app] [LEASE] Load all lease FAILED'),
  LOAD_ALL_LEASES_SUCCESS: type('[app] [LEASE] Load all lease SUCCESS'),
  EXTEND_LEASES: type('[app] [LEASE] Extend leases'),

  LOAD_LEASE_BY_ID: type('[app] [LEASE] Load lease by id'),
  LOAD_LEASE_BY_BOUNDARY_ID: type('[app] [LEASE] Load lease by boundary id'),

  LOAD_LEASE_BY_ID_SUCCESS: type('[app] [LEASE] Load lease by id success'),
  LOAD_LEASE_BY_ID_FAILED: type('[app] [LEASE] Load lease by id fail'),

  SELECT_LEASE: type('[app] [LEASE] Select lease'),

  LOAD_LEASE_TYPES: type('[app] [LEASE] Load all lease types'),
  LOAD_LEASE_TERMS: type('[app] [LEASE] Load all lease terms'),
  LOAD_LEASE_CATEGORIES: type('[app] [LEASE] Load all lease categories'),
  LOAD_LEASE_PAYMENT_DUE: type('[app] [LEASE] Load all lease payment due types'),
  SET_LEASE_TYPES: type('[app] [LEASE] Set all lease types'),
  SET_LEASE_TERMS: type('[app] [LEASE] Set all lease terms'),
  SET_LEASE_CATEGORIES: type('[app] [LEASE] Set all lease categories'),
  SET_LEASE_PAYMENT_DUE: type('[app] [LEASE] Set all lease payment due types'),

  REMOVE_LEASE_SUCCESS: type('[app] [LEASE] Remove lease success'),
};

export class LoadAllLeasesAction implements Action {
  type = LeasesActionTypes.LOAD_ALL_LEASES;

  constructor(public payload: { ranchId: number, year?: number }) {
  }
}

export class LoadAllLeasesFailedAction implements Action {
  type = LeasesActionTypes.LOAD_ALL_LEASES_FAILED;

  constructor(public payload: any) {
  }
}

export class LoadAllLeasesSuccessAction implements Action {
  type = LeasesActionTypes.LOAD_ALL_LEASES_SUCCESS;

  constructor(public payload: { leases: Lease[] }) {
  }
}
export class ExtendLeasesAction implements Action {
  type = LeasesActionTypes.EXTEND_LEASES;

  constructor(public payload: { leases: Lease[] }) {
  }
}


export class LoadLeaseByIdAction implements Action {
  type = LeasesActionTypes.LOAD_LEASE_BY_ID;

  constructor(public payload: { leaseId: number }) {
  }
}

export class LoadLeasesByBoundaryIdAction implements Action {
  type = LeasesActionTypes.LOAD_LEASE_BY_BOUNDARY_ID;

  constructor(public payload: { boundaryId: number }) {
  }
}

export class LoadLeaseByIdFailedAction implements Action {
  type = LeasesActionTypes.LOAD_LEASE_BY_ID_FAILED;

  constructor(public payload: any) {
  }
}


export class LoadLeaseByIdSuccessAction implements Action {
  type = LeasesActionTypes.LOAD_LEASE_BY_ID_SUCCESS;

  constructor(public payload: { lease: Lease }) {
  }
}

export class SelectLeaseAction implements Action {
  type = LeasesActionTypes.SELECT_LEASE;

  constructor(public payload: { leaseId: number }) {
  }
}

export class LoadLeaseTypesAction implements Action {
  type = LeasesActionTypes.LOAD_LEASE_TYPES;

  constructor() {
  }
}

export class LoadLeaseTermsAction implements Action {
  type = LeasesActionTypes.LOAD_LEASE_TERMS;

  constructor() {
  }
}

export class LoadLeaseCategoriesAction implements Action {
  type = LeasesActionTypes.LOAD_LEASE_CATEGORIES;

  constructor() {
  }
}

export class LoadLeasePaymentDueAction implements Action {
  type = LeasesActionTypes.LOAD_LEASE_PAYMENT_DUE;

  constructor() {
  }
}

export class SetLeaseTypesAction implements Action {
  type = LeasesActionTypes.SET_LEASE_TYPES;

  constructor(public payload: { types: GenericIdTitle[] }) {
  }
}

export class SetLeaseTermsAction implements Action {
  type = LeasesActionTypes.SET_LEASE_TERMS;

  constructor(public payload: { terms: GenericIdTitle[] }) {
  }
}

export class SetLeaseCategoriesAction implements Action {
  type = LeasesActionTypes.SET_LEASE_CATEGORIES;

  constructor(public payload: { categories: GenericIdTitle[] }) {
  }
}

export class SetLeasePaymentDueAction implements Action {
  type = LeasesActionTypes.SET_LEASE_PAYMENT_DUE;

  constructor(public payload: { paymentDue: GenericIdTitle[] }) {
  }
}


export class RemoveLeaseSuccessAction implements Action {
  type = LeasesActionTypes.REMOVE_LEASE_SUCCESS;

  constructor(public payload: { leaseId: number }) {
  }
}


export declare type LeasesActions =
  LoadAllLeasesFailedAction | LoadAllLeasesFailedAction | LoadAllLeasesSuccessAction | RemoveLeaseSuccessAction |
  LoadLeaseByIdAction | LoadAllLeasesFailedAction | LoadLeaseByIdSuccessAction | LoadLeasesByBoundaryIdAction
  | SelectLeaseAction | LoadLeaseTermsAction | LoadLeaseTypesAction | LoadLeaseCategoriesAction | LoadLeasePaymentDueAction |
  SetLeaseTypesAction | SetLeaseTermsAction | SetLeaseCategoriesAction | SetLeasePaymentDueAction;
